"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5703],{

/***/ 5530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ action_card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/action-card.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj).attrs(props => Object.assign({
  pt: 2,
  pb: 3,
  px: 3,
  backgroundColor: 'background.lighter',
  borderRadius: 'medium'
}, props))`
  grid-template-columns: minmax(auto, 64px) auto;
  grid-template-areas: ${({
  hasFigure
}) => hasFigure ? `'f c'
        'b b'` : `'c c'
        'b b'`};
`;
const CardContent = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(props => Object.assign({
  my: 3,
  mx: 2
}, props))`
  flex-direction: column;
  justify-content: space-around;
  grid-area: c;
`;
const FigureContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  my: 3,
  mx: 2,
  minWidth: '64px'
}, props))`
  grid-area: f;
`;
const CardFigure = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Image */.Ee)``;
const CardTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: 'medium',
  fontSize: 2
}, props))``;
const CardText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: 'regular',
  fontSize: 1,
  lineHeight: 'big'
}, props))``;
const CardButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  width: 100%;
  text-transform: uppercase;
  grid-area: b;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/action-card.js






const ActionCard = _ref => {
  let {
    data,
    as,
    href,
    image,
    alt,
    onButtonClick,
    buttonProps
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "as", "href", "image", "alt", "onButtonClick", "buttonProps"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "card",
    hasFigure: Boolean(image)
  }, props), Boolean(image) && /*#__PURE__*/react.createElement(FigureContainer, {
    "data-testid": "card-figure"
  }, /*#__PURE__*/react.createElement(CardFigure, {
    src: image,
    alt: alt,
    width: 64,
    height: 64,
    lazy: true
  })), (Boolean(data.title) || Boolean(data.text)) && /*#__PURE__*/react.createElement(CardContent, {
    "data-testid": "card-content"
  }, Boolean(data.title) && /*#__PURE__*/react.createElement(CardTitle, {
    "data-testid": "card-title"
  }, data.title), Boolean(data.text) && /*#__PURE__*/react.createElement(CardText, {
    "data-testid": "card-text"
  }, data.text)), /*#__PURE__*/react.createElement(CardButton, (0,esm_extends/* default */.Z)({
    "data-testid": "card-button",
    forwardedAs: href ? 'a' : as,
    href: href,
    onClick: onButtonClick,
    children: data.action
  }, buttonProps)));
};

 false ? 0 : void 0;
ActionCard.defaultProps = {
  as: 'button',
  data: {
    title: '',
    text: '',
    action: ''
  },
  image: '',
  href: undefined,
  alt: '',
  onButtonClick: () => {}
};
/* harmony default export */ var action_card = (ActionCard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/index.js


/***/ }),

/***/ 92877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ action_detail; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/index.js + 2 modules
var Accordion = __webpack_require__(50616);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/action-detail.styles.js



const Header = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 16px;
  border-bottom: 3px solid #eee;
`;
const Centered = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  text-align: center;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/action-detail.js







function ActionDetail({
  label,
  content,
  detailTitle,
  fullScreen,
  children,
  open,
  onCloseSidebar,
  onChangeOpen
}) {
  const [showDetail, setShowDetail] = (0,react.useState)(open);
  (0,react.useEffect)(() => {
    setShowDetail(open);
    onChangeOpen(open);
  }, [open]);

  function handleClickOutside() {
    setShowDetail(false);
    onChangeOpen(false);
    onCloseSidebar();
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Accordion/* default */.Z, {
    title: label,
    open: !!content,
    onClick: () => {
      setShowDetail(!showDetail);
      onChangeOpen(!showDetail);
    }
  }, content), /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showDetail,
    onClickOutside: handleClickOutside,
    fullScreen: fullScreen
  }, /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement(esm/* ArrowBack */.xhZ, {
    color: "text.light",
    "data-testid": "arrow-back",
    role: "button",
    title: "Fechar detalhes",
    onClick: handleClickOutside
  }), /*#__PURE__*/react.createElement(Centered, null, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "detail-title"
  }, detailTitle))), children));
}

ActionDetail.defaultProps = {
  content: null,
  open: false,
  onCloseSidebar: () => {},
  onChangeOpen: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var action_detail = (ActionDetail);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js


/***/ }),

/***/ 36103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ attribute_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Attribute/index.js + 3 modules
var Attribute = __webpack_require__(77954);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeColor/index.js + 2 modules
var AttributeColor = __webpack_require__(5086);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AttributeVolume/index.js + 4 modules
var AttributeVolume = __webpack_require__(2575);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/AttributeList/attribute-list.js








const Attributes = {
  color: AttributeColor/* default */.Z,
  size: Attribute/* default */.Z,
  voltage: Attribute/* default */.Z,
  volume: AttributeVolume/* default */.Z
};

const getVariationsValueByType = variations => variations == null ? void 0 : variations.reduce((acc, variation) => {
  var _ref;

  acc[variation.type] = Object.assign({}, acc[variation.type], {
    [variation.value]: [...(((_ref = (acc == null ? void 0 : acc[variation.type]) || {}) == null ? void 0 : _ref[variation.value]) || []), variation]
  });
  return acc;
}, {});

const addVariationsToAttributes = (attributes, variations) => attributes.map((attribute, i) => {
  var _ref2, _variationsByValue$at, _attributes, _attributes2;

  const variationsByValue = getVariationsValueByType(variations);
  return Object.assign({}, attribute, {
    variations: (_ref2 = (variationsByValue == null ? void 0 : (_variationsByValue$at = variationsByValue[(_attributes = attributes[i - 1]) == null ? void 0 : _attributes.type]) == null ? void 0 : _variationsByValue$at[(_attributes2 = attributes[i - 1]) == null ? void 0 : _attributes2.current]) || variations) == null ? void 0 : _ref2.reduce((acc, variation) => new Array(...new Set([...acc, variation.id])), [])
  });
});

const AttributeList = _ref3 => {
  let {
    onAttributeChange,
    attributes,
    variations,
    title,
    alignment,
    colorMinLength,
    colorVariant,
    fullWidth,
    showTitle,
    style,
    onVariationClick,
    showWarningText,
    warningMessage,
    iconWarningText
  } = _ref3,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["onAttributeChange", "attributes", "variations", "title", "alignment", "colorMinLength", "colorVariant", "fullWidth", "showTitle", "style", "onVariationClick", "showWarningText", "warningMessage", "iconWarningText"]);

  const minLengths = {
    color: colorMinLength
  };
  const variants = {
    color: colorVariant
  };
  const attributesVariations = addVariationsToAttributes(attributes, variations);
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    width: 1,
    rowGap: 3
  }, attributesVariations.map((attribute, index) => {
    const AttributeComponent = Attributes[attribute == null ? void 0 : attribute.type] || Attribute/* default */.Z;
    const currentVariations = variations.filter(variation => attribute.variations.includes(variation.id) && variation.type === attribute.type);
    return /*#__PURE__*/react.createElement(AttributeComponent, (0,esm_extends/* default */.Z)({
      fullWidth: fullWidth,
      key: `${attribute == null ? void 0 : attribute.type}-${index}`,
      attribute: attribute,
      variations: currentVariations,
      onChange: onAttributeChange,
      onVariationClick: onVariationClick,
      title: title,
      alignment: alignment,
      minLength: minLengths[attribute == null ? void 0 : attribute.type],
      variant: variants[attribute == null ? void 0 : attribute.type],
      showTitle: showTitle,
      style: style,
      showWarningText: showWarningText,
      warningMessage: warningMessage,
      iconWarningText: iconWarningText
    }, props));
  }));
};

AttributeList.defaultProps = {
  attributes: [],
  alignment: 'center',
  colorVariant: 'smooth',
  fullWidth: false,
  variations: [],
  showTitle: true,
  style: {},
  onVariationClick: null,
  showWarningText: false,
  warningMessage: '',
  iconWarningText: ''
};
 false ? 0 : void 0;
/* harmony default export */ var attribute_list = (AttributeList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/AttributeList/index.js


/***/ }),

/***/ 88586:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var build_esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/best-installment.styles.js






const Container = styled_components_browser_esm/* default.section */.ZP.section`
  padding: 12px;
  border: solid 1px ${props => (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('whisper')(props)};
  border-radius: 4px;
  ${index_esm/* space */.Dh}
`;
const PriceInformation = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  justify-content: space-between;
`;
const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-weight: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  cursor: pointer;
  text-decoration: underline;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  line-height: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('lineHeights.input')(props)}em;
`;
const SidebarHeader = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)`
  padding: 12px;
  border-bottom: 1px solid ${props => (0,stereo_ui_styles_build_esm/* getBackgroundColor */.dF)('darker')(props)};
  align-items: center;
  grid-template-columns: auto 1fr;
  grid-gap: 1em;
  margin-bottom: 20px;
`;
const SidebarTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/best-installment.data.js
const CardLabel = `Cartão de crédito`;
const PaymentsWay = `Formas de pagamento`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PaymentMethods/index.js + 5 modules
var PaymentMethods = __webpack_require__(563);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/best-installment.js










const BestInstallment = _ref => {
  let {
    plan,
    payments,
    onClick,
    onClose,
    onPaymentMethodChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["plan", "payments", "onClick", "onClose", "onPaymentMethodChange"]);

  const [open, setOpen] = (0,react.useState)(false);

  const handleOpenSidebar = () => {
    setOpen(true);
    onClick(plan);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const {
    paymentMethodDescription,
    totalAmount,
    quantity,
    amount
  } = plan;
  return /*#__PURE__*/react.createElement(Container, props, /*#__PURE__*/react.createElement(PriceInformation, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Label, {
    onClick: handleOpenSidebar,
    role: "button",
    "aria-hidden": true,
    "aria-label": "abrir m\xE9todos de pagamento"
  }, CardLabel), /*#__PURE__*/react.createElement(Description, null, paymentMethodDescription)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Description, {
    textAlign: "right"
  }, (0,build_esm/* currencyFormatter */.oB)({
    value: totalAmount
  })), /*#__PURE__*/react.createElement(Description, {
    fontWeight: "500"
  }, quantity, "x ", (0,build_esm/* currencyFormatter */.oB)({
    value: amount
  })))), /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    visible: open,
    direction: "right",
    onClickOutside: handleClose,
    "data-testid": "sidebar-payments"
  }, /*#__PURE__*/react.createElement(SidebarHeader, null, /*#__PURE__*/react.createElement(esm/* Close */.x8P, {
    color: "#bcbcbc",
    onClick: handleClose,
    role: "button",
    title: "fechar m\xE9todos de pagamento"
  }), /*#__PURE__*/react.createElement(SidebarTitle, {
    fontWeight: "normal"
  }, PaymentsWay)), /*#__PURE__*/react.createElement(PaymentMethods/* default */.Z, {
    payments: payments,
    onChange: onPaymentMethodChange
  })));
};

 false ? 0 : void 0;
BestInstallment.defaultProps = {
  plan: {},
  payments: {},
  onClick: () => ({}),
  onClose: () => ({}),
  onPaymentMethodChange: () => ({})
};
/* harmony default export */ var best_installment = ((/* unused pure expression or super */ null && (BestInstallment)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/index.js


/***/ }),

/***/ 18559:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormFull/cardan-form-full.styles.js



const Form = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(0,esm/* themeGet */.R)('space.3')}px;
`;
const Row = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 8px;
`;
const Column = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu)`
  display: flex;
  justify-content: end;
  flex: ${props => props.sizeFraction ? props.sizeFraction : '1'} 1 0;
  min-width: 170px;
`;
const CustomSelect = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Select */.Ph)`
  display: flex;
  width: 100%;
  select {
    border-radius: 12px;
    font-size: ${(0,esm/* themeGet */.R)('fontSizes.1')}px;
    color: ${(0,esm/* themeGet */.R)('colors.gray')};
    padding: 11px 16px;
  }

  select:disabled {
    cursor: not-allowed;
  }

  select option {
    color: black;
  }

  select:has(option:checked:not([value])),
  select:has(option:checked:not([value=''])) {
    color: black;
  }

  select:has(option:checked:not([value])) option,
  select:has(option:checked:not([value=''])) option {
    color: black;
  }
`;
const CustomButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  width: 100%;
  height: 40px;
  border-radius: 12px;
  padding: 12px 16px;
  ${({
  border
}) => !border && styled_components_browser_esm/* css */.iv`
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
    `}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormFull/cardan-form-full.js





function CardanFormFull(_ref) {
  let {
    plateButton,
    submitButton,
    handleFieldChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["plateButton", "submitButton", "handleFieldChange"]);

  const spreadSelectOptions = (label, optionsList, currentValue) => {
    const options = Array.isArray(optionsList) ? optionsList.map(option => ({
      label: option == null ? void 0 : option.name,
      selected: (option == null ? void 0 : option.value) === currentValue,
      value: option == null ? void 0 : option.value
    })) : [];
    return [{
      label,
      selected: currentValue === '',
      value: '',
      isPlaceholder: true
    }, ...options];
  };

  const mappingSelect = ['brand', 'model', 'year', 'version'];
  return /*#__PURE__*/react.createElement(Form, {
    as: "form",
    "data-testid": "cardan-form"
  }, /*#__PURE__*/react.createElement(Row, null, mappingSelect.map(id => {
    const selectKey = `cardan-${id}`;
    const field = props[id];
    const selectOptions = spreadSelectOptions(field.label, field.options, field.value);
    return /*#__PURE__*/react.createElement(Column, {
      key: selectKey
    }, /*#__PURE__*/react.createElement(CustomSelect, {
      id: selectKey,
      options: selectOptions,
      onChange: value => handleFieldChange(id, value),
      disabled: field.disabled,
      "data-testid": selectKey
    }));
  })), /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(Column, {
    sizeFraction: "0.25"
  }), /*#__PURE__*/react.createElement(Column, {
    sizeFraction: "0.25"
  }), /*#__PURE__*/react.createElement(Column, {
    sizeFraction: "0.25"
  }, plateButton.isAvailable && /*#__PURE__*/react.createElement(CustomButton, {
    variation: plateButton.variation || 'fill',
    border: plateButton.variation === 'outline',
    disabled: plateButton.disabled,
    onClick: plateButton.onClick,
    uppercase: false,
    size: "small",
    "data-testid": "cardan-form-button-plateButton"
  }, plateButton.label)), /*#__PURE__*/react.createElement(Column, {
    sizeFraction: "0.25"
  }, /*#__PURE__*/react.createElement(CustomButton, {
    variation: submitButton.variation || 'fill',
    border: submitButton.variation === 'outline',
    disabled: submitButton.disabled,
    onClick: submitButton.onClick,
    uppercase: false,
    size: "small",
    "data-testid": "cardan-form-button-submitButton"
  }, submitButton.label))));
}

const optionPropType =  false ? 0 : {};
const selectPropType =  false ? 0 : {};
const buttonPropType =  false ? 0 : {};
 false ? 0 : void 0;
CardanFormFull.defaultProps = {
  plateButton: {
    disabled: false,
    isAvailable: true,
    onClick: null,
    label: 'Busca por placa',
    variation: 'outline'
  },
  submitButton: {
    disabled: false,
    onClick: null,
    label: 'Procurar',
    variation: 'fill'
  },
  brand: {
    label: 'Todas as marcas',
    options: [],
    value: '',
    disabled: false
  },
  model: {
    label: 'Todos os modelos',
    options: [],
    value: '',
    disabled: true
  },
  year: {
    label: 'Todos os anos',
    options: [],
    value: '',
    disabled: true
  },
  version: {
    label: 'Todas as versões',
    options: [],
    value: '',
    disabled: true
  },
  handleFieldChange: null
};
/* harmony default export */ var cardan_form_full = ((/* unused pure expression or super */ null && (CardanFormFull)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormFull/index.js


/***/ }),

/***/ 37331:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/carPlateMask.js
var carPlateMask = __webpack_require__(68609);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormLicensePlate/cardan-form-license-plate.styles.js



const defaultStyles = styled_components_browser_esm/* css */.iv`
  font-size: ${(0,esm/* themeGet */.R)('fontSizes.1')}px;
  border-radius: 12px;
  padding: 12px 16px;
  height: 40px;
`;
const Form = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC).attrs(() => ({
  as: 'form'
}))`
  width: 100%;
`;
const Row = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  width: 100%;
  gap: ${(0,esm/* themeGet */.R)('space.3')}px;
  margin-bottom: ${(0,esm/* themeGet */.R)('space.3')}px;
  min-height: 14px;
`;
const LicensePlateInput = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Input */.II)`
  border-radius: 8px;
  padding: 12px 16px;
  height: 40px;
  width: auto;
  color: ${(0,esm/* themeGet */.R)('colors.gray')};
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(0,esm/* themeGet */.R)('colors.gray')};
  }
`;
const LicensePlateButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  ${defaultStyles}
`;
const LicensePlateLink = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  ${defaultStyles}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormLicensePlate/cardan-form-license-plate.js






function CardanFormLicensePlate({
  onSubmit,
  onRedirect,
  submitButtonLabel,
  redirectButtonLabel,
  inputLabel,
  inputValue = '',
  errorMsg
}) {
  const [licensePlateNumber, setLicensePlateNumber] = (0,react.useState)((0,carPlateMask/* default */.Z)(inputValue));
  const [displayError, setDisplayError] = (0,react.useState)(false);

  const handleInputChange = e => {
    setLicensePlateNumber((0,carPlateMask/* default */.Z)(e.target.value));
    setDisplayError(false);
  };

  const handleSubmit = (0,react.useCallback)(e => {
    e.preventDefault();
    setDisplayError(true);
    onSubmit({
      licensePlateNumber
    });
  }, [licensePlateNumber, onSubmit]);
  const handleRedirect = (0,react.useCallback)(e => {
    e.preventDefault();
    onRedirect();
  }, [onRedirect]);
  return /*#__PURE__*/react.createElement(Form, {
    as: "form",
    "data-testid": "cardan-form"
  }, /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontSize: 1
  }, "Digite a placa do ve\xEDculo")), /*#__PURE__*/react.createElement(Row, {
    style: {
      marginBottom: '13px'
    }
  }, /*#__PURE__*/react.createElement(LicensePlateInput, {
    placeholder: inputLabel,
    onChange: handleInputChange,
    value: licensePlateNumber,
    "data-testid": "cardan-number-license-plate"
  }), /*#__PURE__*/react.createElement(LicensePlateButton, {
    disabled: licensePlateNumber.length !== 8,
    onClick: handleSubmit,
    uppercase: false,
    "data-testid": "cardan-form-submit-button"
  }, submitButtonLabel), onRedirect && /*#__PURE__*/react.createElement(LicensePlateLink, {
    onClick: handleRedirect,
    uppercase: false,
    size: "small",
    variation: "outline",
    "data-testid": "cardan-form-redirect-button"
  }, redirectButtonLabel)), /*#__PURE__*/react.createElement(Row, {
    style: {
      marginBottom: '0px'
    }
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontSize: 1,
    color: "red"
  }, displayError && errorMsg)));
}

CardanFormLicensePlate.defaultProps = {
  submitButtonLabel: 'Buscar veículo',
  redirectButtonLabel: 'Buscar sem placa',
  inputLabel: 'Número da Placa'
};
 false ? 0 : void 0;
/* harmony default export */ var cardan_form_license_plate = ((/* unused pure expression or super */ null && (CardanFormLicensePlate)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormLicensePlate/index.js


/***/ }),

/***/ 704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ coupon_card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CouponCard/coupon-card.styles.js


const Container = styled_components_browser_esm/* default.div */.ZP.div`
  background: ${props => (0,esm/* getBackgroundColor */.dF)('white')(props)};
  border-radius: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
  padding: 20px 28px;
  text-align: left;
  max-width: 421px;
  width: 100%;
  height: 137px;
  position: relative;
  border: 1px solid #e0e0e0;
  padding-bottom: 30px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 20px;
    background: #f5f5f5;
    border-radius: 0 15px 15px 0;
    border: 1px solid #e0e0e0;
  }

  &::before {
    top: 30px;
    left: -1px;
    border-left-color: #f5f5f5;
  }

  &::after {
    bottom: 30px;
    left: -1px;
    border-left-color: #f5f5f5;
  }
`;
const SideCut = styled_components_browser_esm/* default.div */.ZP.div`
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 20px;
    background: #f5f5f5;
    border-radius: 15px 0 0 15px;
    border: 1px solid #e0e0e0;
  }

  &::before {
    top: 30px;
    right: -1px;
    border-right-color: #f5f5f5;
  }

  &::after {
    bottom: 30px;
    right: -1px;
    border-right-color: #f5f5f5;
  }
`;
const DashedLine = styled_components_browser_esm/* default.div */.ZP.div`
  position: absolute;
  top: 40px;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  border-top: 1px dashed #e0e0e0;
`;
const CouponHeader = styled_components_browser_esm/* default.div */.ZP.div`
  font-weight: bold;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.2')(props)}px;
  margin-bottom: 12px;
  color: ${props => (0,esm/* themeGet */.R)('colors.black')(props)};
  text-align: left;
`;
const CouponContent = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 0;
  gap: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CouponCard/coupon-card.js






const CouponCard = _ref => {
  let {
    headerText,
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["headerText", "children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "coupon-card"
  }, props), /*#__PURE__*/react.createElement(SideCut, null), headerText && /*#__PURE__*/react.createElement(CouponHeader, {
    "data-testid": "coupon-header"
  }, headerText), /*#__PURE__*/react.createElement(DashedLine, {
    "data-testid": "coupon-dashed-line"
  }), /*#__PURE__*/react.createElement(CouponContent, {
    "data-testid": "coupon-content"
  }, children));
};

 false ? 0 : void 0;
CouponCard.defaultProps = {
  headerText: ''
};
/* harmony default export */ var coupon_card = (CouponCard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CouponCard/index.js


/***/ })

}]);